import { useMutation } from "react-query";
import { getOfficeByOfficeHierarchyId } from "../../../../actions/CarrierAgreementMgmt/OfficeSettings";

const useSearchOfficeByOfficeHierarchyId = () => {
  return useMutation(getOfficeByOfficeHierarchyId);
};

export default useSearchOfficeByOfficeHierarchyId;
